module.exports = __webpack_public_path__ + "img/600.ee16f028.jpg";